export default "__VITE_ASSET__2awJ$0Dt__"